// extracted by mini-css-extract-plugin
module.exports = {"h1":"styles_h1__ACtER","section":"styles_section__fsgAA","link":"styles_link__J3at0"};